export const RegexExpressions = {
    email:
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    username: /^(?=[a-zA-Z0-9._]{2,18}$)(?!.*[_.]{2})[^_.].*[^_.]$/,
    name: /^[\\p{L} .'-]+$/,
    // eslint-disable-next-line no-useless-escape
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})/,
};

export const Endpoints = {
    Departmets: {
        GetDepartmets: "departments",
    },
    Services: {
        GetServices: "services",
        GetAvailableTimeSlots: "services/available",
        Reserve: "services/reserve",
        ReserveUpdate: "services/reserve/update",
        ReserveConfirm: "services/reserve/confirm",
        ResendCode: "services/reserve/resend-sms",
        SystemUpdatereservation: "services/reserve/system/update"
    },
};

export const QueryKeys = {
    department: "department",
    service: "service",
    serviceId: "serviceId",
    date: "date",
    time: "time",
    personalData: "personalData",
    successData: "successData",
    additionalData: "additionalData"
};
export const RomanianMonths = {
    January: "ianuarie",
    February: "februarie",
    March: "martie",
    April: "aprilie",
    May: "mai",
    June: "iunie",
    July: "iulie",
    August: "august",
    September: "septembrie",
    October: "octombrie",
    November: "noiembrie",
    December: "decembrie",
}

export const RomanianMonthsShort = {
    January: "ian",
    February: "feb, ",
    March: " mar, ",
    April: "apr ",
    May: "mai",
    June: "iun",
    July: "iul",
    August: "aug",
    September: "sep",
    October: "oct",
    November: "nov",
    December: "dec",
}
